import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ItemName from '../../../shared/ItemName';
import PageTitleAsBreadCrumbs from '../../../shared/PageTitleAsBreadCrumbs';
import { propertySaveService } from '../../../services/propertySaveService';
import { propertyNamesService } from '../../../services/propertyNamesService';
import PropertyItemDescription from './PropertyItemDescription';
import PropertyItemType from './PropertyItemType';
import PropertyItemCategory from './PropertyItemCategory';
import PropertyItemVitaminSlider from './PropertyItemVitaminSlider';
import NonEditableItemCode from '../../../shared/NonEditableItemCode';
import LastUpdateTime from '../../../shared/LastUpdateTime';
import PropertyItemUserDisplayList from './PropertyItemUserDisplayList';
import PropertyCanonLists from './PropertyCanonLists';

const propertyNameSaveService = {
    updateItemLocalization(locale, value) {
        propertySaveService.updatePropertyName(locale, value);
    },
};

const EditPropertyTab = () => {
    const [activePropertyItem, setActivePropertyItem] = useState({});
    const { id } = useParams();

    const updateActiveProperty = () => {
        setActivePropertyItem({...propertySaveService.getProperty()});
    };

    useEffect(() => {
        if (id) {
            propertySaveService.loadProperty(id, updateActiveProperty);
            propertySaveService.registerItemUpdateObserver(updateActiveProperty);
        }
        return () => {
            propertySaveService.unRegisterItemUpdateObserver(updateActiveProperty);
        };
    }, [id]);

    return (
        activePropertyItem.id &&
        <>
            <PageTitleAsBreadCrumbs />
            <article className="product__article product__article-add">
                <LastUpdateTime itemSaveService={propertySaveService}/>
                <form className="product__form product__form_large">
                    <ItemName
                        itemCode={propertySaveService.getProperty()}
                        itemService={propertyNamesService}
                        itemSaveService={propertyNameSaveService}
                    />
                    <NonEditableItemCode itemCode={activePropertyItem.propertyName} />
                    <PropertyCanonLists />
                    <PropertyItemType />
                    <PropertyItemCategory />
                    <PropertyItemVitaminSlider />
                    <PropertyItemUserDisplayList />
                    <PropertyItemDescription />
                </form>
            </article>
        </>
    );
};

export default EditPropertyTab;
